<template>
    <div class="layer">
        <div class="wrap">
            <div class="login_content">
                <div class="login_img">
                    <img src="@/assets/largeLogo.png" alt="" />
                </div>
                <form>
                    <div class="login_input">
                        <input type="text" id="id_input" v-model="state.id" placeholder="아이디" />
                        <input type="password" v-model="state.password" placeholder="비밀번호" />
                    </div>
                    <div class="login_btn" @click="login">
                        <button>로그인</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script lang="ts" config>
    import { apiService, globalStore, onMounted, reactive, returnCode, router, userStore } from "@/BaseComponent";

    export default {
        props: {},
        components: {},
        setup() {
            const { changeCode } = returnCode();
            const user = userStore();
            const global = globalStore();
            const state = reactive({
                id: "" as string,
                password: "" as string,
            });
            onMounted(() => {
                user.$reset();
                global.$reset();
                document.getElementById("id_input")?.focus();
            });
            const login = async (e: Event) => {
                e.preventDefault();
                if (state.id !== "" && state.password !== "") {
                    const res = await apiService.base.login(state.id, state.password);
                    if (res.returnCode === 0) {
                        return router.push("/");
                    }
                    if (res.returnCode === 9) {
                        return alert("관리자가 승인후 로그인이 가능합니다.");
                    }
                    if (res.returnCode === 8) {
                        return router.push("/agree");
                    }
                    if (res.returnCode === 999) {
                        return alert("사용 불가능한 계정입니다.");
                    }
                    return alert(changeCode(res.returnCode));
                } else {
                    alert("id 또는 password 전부 입력해주세요");
                }
            };
            return {
                state,
                login,
            };
        },
    };
</script>
